export enum RoleEnum {
  Owner = 'ADMIN',
  Admin = 'TEAM_ADMIN',
  Developer = 'TEAM_DEVELOPER',
  User = 'TEAM_USER',
}
